<template>
   <label role="checkbox" :class="className" :aria-checked="ariaChecked">
        <input type="checkbox"
             class="v-switch-input"  @change.stop="toggle">
        <div class="v-switch-core"
            :style="coreStyle">
            <div class="v-switch-button"
                :style="buttonStyle">
            </div>
        </div>
      <template v-if="labels">
            <span class="v-switch-label v-left"
                  :style="labelStyle"
                  v-if="toggled"
                  v-html="labelChecked"></span>
            <span class="v-switch-label v-right"
                  :style="labelStyle"
                  v-else
                  v-html="labelUnchecked"></span>
          </template>
    </label>
</template>

<script>
    const constants = {
        colorChecked: '#FFFFFF',
        colorUnchecked: '#FFFFFF',
        cssColors: false,
        labelUnchecked: 'OFF',
        width: 50,
        height: 26,
        margin: 4
    };
    const contains = function contains(object, title) {
        return (typeof object === 'undefined' ? 'undefined' : typeof(object)) === 'object' && object.hasOwnProperty(title);
    };

    const px = function px(v) {
        return v + 'px';
    };

    export default {
        name: "toggle",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            sync: {
                type: Boolean,
                default: false
            },
            speed: {
                type: Number,
                default: 300
            },
            param: {
                type: [Object],
                default: null
            },
            color: {
                type: [String, Object],
                validator: function validator(value) {
                    return (typeof value === 'undefined' ? 'undefined' : typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'string';
                }
            },
            mainColor: {
                type: String,
                default: null
            },
            cssColors: {
                type: Boolean,
                default1: false
            },
            labels: {
                type: [Boolean, Object],
                default: true,
                validator: function validator(value) {
                    return (typeof value === 'undefined' ? 'undefined' : typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
                }
            },
            height: {
                type: Number,
                default: constants.height
            },
            width: {
                type: Number,
                default: constants.width
            }
        },
        computed: {
            labelCheckedHtml() {
                const color = this.mainColor ? this.mainColor : '#256AB3';
                return `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 15 15">
                    <path fill="${color}" fill-rule="nonzero" d="M14.78 3.24a.707.707 0 0 0-1.06 0l-8.986 7.786-3.454-2.76a.707.707 0 0 0-1.06 0 .87.87 0 0 0 0 1.156l3.984 3.339a.707.707 0 0 0 1.06 0l9.516-8.365a.87.87 0 0 0 0-1.157z"/>
                </svg>`
            },
            className: function className() {
                var toggled = this.toggled,
                    disabled = this.disabled;

                return ['vue-js-switch', { toggled: toggled, disabled: disabled }];
            },
            ariaChecked: function ariaChecked() {
                return this.toggled.toString();
            },
            coreStyle: function coreStyle() {
                return {
                    width: px(this.width),
                    height: px(this.height),
                    backgroundColor: this.cssColors ? null : this.colorCurrent,
                    borderRadius: px(Math.round(this.height / 2)),
                    borderColor: this.mainColor
                };
            },
            buttonRadius: function buttonRadius() {
                return this.height - constants.margin * 2;
            },
            distance: function distance() {
                return px(this.width - this.height + constants.margin);
            },
            buttonStyle: function buttonStyle() {
                return {
                    width: px(this.buttonRadius),
                    height: px(this.buttonRadius),
                    transition: 'transform ' + this.speed + 'ms',
                    transform: this.toggled ? 'translate3d(' + this.distance + ', 3px, 0px)' : null,
                    backgroundColor: this.toggled ? this.mainColor : null,
                    borderColor: this.mainColor
                };
            },
            labelStyle: function labelStyle() {
                return {
                    lineHeight: px(this.height)
                };
            },
            colorChecked: function colorChecked() {
                var color = this.color;

                if ((typeof color === 'undefined' ? 'undefined' : typeof(color)) !== 'object') {
                    return color || constants.colorChecked;
                }
                return contains(color, 'checked') ? color.checked : constants.colorChecked;
            },
            colorUnchecked: function colorUnchecked() {
                var color = this.color;

                return contains(color, 'unchecked') ? color.unchecked : constants.colorUnchecked;
            },
            colorCurrent: function colorCurrent() {
                return this.toggled ? this.colorChecked : this.colorUnchecked;
            },
            labelChecked: function labelChecked() {
                return contains(this.labels, 'checked') ? this.labels.checked : this.labelCheckedHtml;
            },
            labelUnchecked: function labelUnchecked() {
                return contains(this.labels, 'unchecked') ? this.labels.unchecked : constants.labelUnchecked;
            }
        },
        watch: {
            value: function value(_value) {
                if (this.sync) {
                    this.toggled = !!_value;
                }
            }
        },
        data: function data() {
            return {
                toggled: !!this.value
            };
        },

        methods: {
            toggle: function toggle(event) {
                this.toggled = !this.toggled;
                this.$emit('input', this.toggled);
                this.$emit('change', {
                    value: this.toggled,
                    srcEvent: event,
                    item: this.param
                });
            }
        }

    }
</script>

<style scoped>

</style>
